<p-panel>
	<app-reactive-form-builder
		(stableValueChanges)="stableValueChanges($event)"
		(goBack)="goBack()"
		[form]="form.formFields"
		[id]="getModel().id ?? ''"
		[request]="this.getType() === 1 ? this.productApi.productos.PUT : this.productApi.productos.POST"
		[getRequest]="productApi.productos.GET"
		[dropdownLoadTrigger]="dropdownLoadTrigger"
	>
	</app-reactive-form-builder>
</p-panel>
